module.exports = __webpack_public_path__ + "img/cp-diver-1.8feb69b4.svg";